import { CommitmentKpi, GoalStatus } from '../../coaching-base/general';
import { ObjectDateTransformer } from '../../coaching-insight/coaching-insight.model';
import { GoalsCollection } from '../goals-collection.model';
import { FocusKPI } from '../models/commitment.model';

export function goalsCollectionTransformer(
    commitmentKpis?: CommitmentKpi[],
    focusKpis?: FocusKPI[],
    otherCommitmentKpis?: CommitmentKpi[],
): GoalsCollection {
    const result: GoalsCollection = {
        commitmentKpis: commitmentKpis ?? [],
        focusKpis: focusKpis ?? [],
        goalsFromOtherCommitments: otherCommitmentKpis ?? [],
    };

    if (commitmentKpis) {
        const dateTransformer = new ObjectDateTransformer<CommitmentKpi>({
            // dateSet: null,    // utc
            createdOn: 'L',
            updatedOn: 'L',
            estimatedCompletionDate: 'L',
        });

        result.commitmentKpis = result.commitmentKpis.map((a) => {
            const transformedData = dateTransformer.transform(a);
            transformedData.tracking_id = Math.random();
            let percentToTarget = transformedData.percentToTarget;

            if (percentToTarget < 0) {
                percentToTarget = 0;
            } else if (percentToTarget > 999) {
                percentToTarget = 999;
            }

            transformedData.percentToTarget = percentToTarget;
            return transformedData;
        });
    }

    if (focusKpis) {
        result.focusKpis.forEach((s) => {
            s.tracking_id = Math.random();
        });
    }

    if (otherCommitmentKpis) {
        result.goalsFromOtherCommitments = result.goalsFromOtherCommitments
            .filter((x) => x.statusId !== GoalStatus.CLOSED)
            .sort(
                (x, y) =>
                    new Date(y.createdOn).getTime() -
                    new Date(x.createdOn).getTime(),
            );

        const dateTransformer = new ObjectDateTransformer<CommitmentKpi>({
            // dateSet: null,
            createdOn: 'L',
            updatedOn: 'L',
            estimatedCompletionDate: 'L',
        });

        result.goalsFromOtherCommitments = result.goalsFromOtherCommitments.map(
            (a) => {
                const f = dateTransformer.transform(a);
                f.tracking_id = Math.random();

                // ensure this is set
                f.isOriginalGoal = true;

                return f;
            },
        );
    }

    return result;
}
